import {Controller} from "stimulus"

export default class extends Controller {
    static targets = ["searchResults", "searchItem"]

    connect() {
        console.log("log from searchForm controller")
        this.timeout = null
        this.currentController = null
        this.lastSearchValue = ""

        if (this.hasSearchItemTarget) {
            this.searchItemTarget.addEventListener("search", (event) => {
                const resultsArea = event.target.closest(".search-container").querySelector(".bl-search-results")
                resultsArea.classList.remove("showing")
                resultsArea.innerHTML = ''
            })
        }

        if (this.hasSearchResultsTarget) {
            this.searchResultsTarget.addEventListener("click", (event) => {
                if (event.target.closest('a') && !event.ctrlKey && !event.metaKey && !event.altKey && !event.shiftKey) {
                    if (this.currentController) {
                        this.currentController.abort()
                    }
                    clearTimeout(this.timeout)
                    this.searchResultsTarget.classList.remove("showing")
                }
            })
        }

        if (this.hasSearchItemTarget && this.hasSearchResultsTarget) {
            const showResultsElement = document.querySelector('.show-results-on-page');
            const cachedSearchValue = sessionStorage.getItem('lastSearchValue');
            const cachedResults = sessionStorage.getItem('lastSearchResults');

            if (showResultsElement && cachedSearchValue && cachedResults) {
                this.searchItemTarget.value = cachedSearchValue;
                this.lastSearchValue = cachedSearchValue;
                const frameId = this.searchItemTarget.dataset.frameId || 'search_results';
                const frame = this.searchResultsTarget.querySelector(`#${frameId}`);
                frame.innerHTML = cachedResults;
                this.searchResultsTarget.classList.add("showing");
            }
        }
    }

    clearResults(event) {
        const resultsArea = event.target.closest('.search-container').querySelector('.bl-search-results')
        const frameId = event.target.dataset.frameId || 'search_results'
        resultsArea.querySelector(`#${frameId}`).innerHTML = ''
        event.target.closest('.search-container').classList.remove('show-results-on-page') // Add this line
    }

    requestSearch(event) {

        // Ignore modifier keys
        if (event.key === 'Control' ||
            event.key === 'Shift' ||
            event.key === 'Alt' ||
            event.key === 'Meta' ||
            event.ctrlKey ||
            event.altKey ||
            event.metaKey) {
            return
        }

        if (this.hasSearchResultsTarget) {
            this.searchResultsTarget.addEventListener("click", (event) => {
                const link = event.target.closest('a')
                if (!link) return

                // For ctrl/cmd clicks, prevent Turbo from handling it
                if (event.ctrlKey || event.metaKey) {
                    event.preventDefault()
                    event.stopPropagation()  // Stop event from bubbling
                    window.open(link.href, '_blank')
                    return
                }

                // Normal click handling
                if (!event.ctrlKey && !event.metaKey && !event.altKey && !event.shiftKey) {
                    if (this.currentController) {
                        this.currentController.abort()
                    }
                    clearTimeout(this.timeout)
                    this.searchResultsTarget.classList.remove("showing")
                }
            })
        }

        this.searchResultsTarget.addEventListener("mouseover", (event) => {
            const link = event.target.closest('a')
            if (link) {
                event.preventDefault()
                event.stopPropagation()
            }
        }, {capture: true})


        // Handle Enter - submit form unless prevented by data attribute
        if (event.key === "Enter") {
            if (event.target.dataset.searchformPreventSubmit === "true") {
                event.preventDefault()
                return
            }
            event.target.closest('form')?.submit()
            return
        }

        // Handle Escape - abort current searches and clear results
        if (event.key === "Escape") {
            if (this.currentController) {
                this.currentController.abort()
            }
            clearTimeout(this.timeout)
            const resultsArea = event.target.closest('.search-container').querySelector('.bl-search-results')
            resultsArea.classList.remove("showing")
            resultsArea.innerHTML = ''
            return
        }
        const searchValue = event.target.value

        // Only proceed if the search value has changed
        const previousSearchValue = this.lastSearchValue
        if (searchValue === previousSearchValue) {
            return
        }

        // Regular search handling
        clearTimeout(this.timeout)
        this.lastSearchValue = searchValue
        const resultsArea = event.target.closest('.search-container').querySelector('.bl-search-results')
        const frameId = event.target.dataset.frameId || 'search_results'

        // Clear out any previous results before issuing a new search to avoid duplicates
        if (previousSearchValue) {
            const resultsFrame = resultsArea.querySelector(`#${frameId}`)
            if (resultsFrame) {
                resultsFrame.innerHTML = ''
            }
            resultsArea.classList.remove("showing")
        }
        this.timeout = setTimeout(() => {
            const searchValue = event.target.value
            if (searchValue.length > 2) {
                resultsArea.classList.add("showing")
                const idSearchPattern = /^(\D{2}-\d{1,9}|(pl|pp|tx)-.{1,11})$/
                const scopeData = event.target.dataset.searchformScope || event.target.dataset.scope || "all"
                const searchTypes = idSearchPattern.test(searchValue)
                    ? ['id']
                    : Array.from(new Set(scopeData.split(",").map(type => type.trim()).filter(Boolean)))
                const frame = resultsArea.querySelector(`#${frameId}`)
                frame.innerHTML = `
                    <div class="searching-message">
                        <p>Searching...</p>
                        <div class="spinner"></div>
                    </div>`
                // Abort any existing searches
                if (this.currentController) {
                    this.currentController.abort()
                }
                this.currentController = new AbortController()

                const excludedIds = event.target.dataset.excludedIds || ""

                searchTypes.forEach(searchType => {
                    console.log("searching for " + searchType + " with value " + searchValue)
                    let searchUrl = `/search/query?type=${searchType}&search=${searchValue}&frame_id=${frameId}`
                    if (excludedIds) {
                        searchUrl += `&excluded=${encodeURIComponent(excludedIds)}`
                    }
                    fetch(searchUrl, {
                        headers: {
                            "Accept": "text/vnd.turbo-stream.html",
                            "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content
                        },
                        signal: this.currentController.signal
                    })
                        .then(response => response.text())
                        .then(html => {
                            event.target.closest('.search-container').classList.add('show-results-on-page')

                            if (event.target.value === searchValue) {  // Only update if value hasn't changed
                                Turbo.renderStreamMessage(html)
                                sessionStorage.setItem('lastSearchValue', searchValue);
                                sessionStorage.setItem('lastSearchResults', frame.innerHTML);
                            }
                            resultsArea.querySelector(".searching-message")?.remove()
                        })
                        .catch(error => {
                            if (error.name === 'AbortError') {
                                console.log('Fetch aborted')
                            } else {
                                console.error('Fetch error:', error)
                            }
                        })
                })
            } else {
                resultsArea.classList.remove("showing")
                event.target.closest('.search-container').classList.remove('show-results-on-page')
            }
        }, 300)
    }

    requestIdSearch(event) {
        clearTimeout(this.timeout)
        const abortSignal = new AbortController();
        const resultsArea = event.target.closest('.search-container').querySelector('.bl-search-results');
        const frameId = event.target.dataset.frameId || 'search_results';

        if (event.which == 13 || event.keyCode == 13) {
            console.log('aborting Type Ahead search');
            abortSignal.abort();
            resultsArea.classList.remove("showing")
        }

        this.timeout = setTimeout(() => {
            if (event.target.value.length > 2) {
                resultsArea.classList.add("showing");
                fetch("/search/query.html?search=" +
                    encodeURIComponent(event.target.value) +
                    "&type=" + encodeURIComponent(event.target.dataset.scope) +
                    "&frame_id=" + encodeURIComponent(frameId) +
                    "&more=" + encodeURIComponent(event.target.dataset.more) +
                    "&limit=" + encodeURIComponent((event.target.dataset.limit || 5)) +
                    "&excluded=" + encodeURIComponent((event.target.dataset.excludedIds || "[]")),
                    {signal: abortSignal.signal})
                    .then(response => {
                        return response.text();
                    })
                    .then(html => {
                        event.target.closest('.search-container').classList.add('show-results-on-page');
                        resultsArea.innerHTML = html;
                    }).catch(error => {
                    if (error.name !== 'AbortError') {
                        console.warn(error);
                        Honeybadger.notify(error);
                        document.querySelector('#flash-area').innerHTML = "<p class=\"notice\">" + error.message + "</p>";
                    }
                });
            } else {
                resultsArea.classList.remove("showing");
            }
        }, 1100);
    }

    disconnect() {
        clearTimeout(this.timeout)
        if (this.currentController) {
            this.currentController.abort()
        }
        sessionStorage.removeItem('lastSearchValue');
        sessionStorage.removeItem('lastSearchResults');
    }
}
